import React from "@public/react.svg";
import Next from "@public/next.svg";
import Vue from "@public/vue.svg";
import Tailwind from "@public/tailwind.svg";
import Storybook from "@public/storybook.svg";
import Typescript from "@public/typescript.svg";
import Redux from "@public/redux.svg";
import Node from "@public/node.svg";
import Express from "@public/express.svg";
import Strapi from "@public/strapi.svg";
import Firebase from "@public/firebase.svg";
import MongoDB from "@public/mongodb.svg";
import Payload from "@public/payload.svg";
import Docker from "@public/docker.svg";
import Wordpress from "@public/wordpress.svg";
import Sendgrid from "@public/sendgrid.svg";

const skillsConfig = [
  { title: "React", logo: React.src },
  { title: "Next", logo: Next.src },
  { title: "Vue", logo: Vue.src },
  { title: "Tailwind", logo: Tailwind.src },
  { title: "Storybook", logo: Storybook.src },
  { title: "Typescript", logo: Typescript.src },
  { title: "Redux", logo: Redux.src },
  { title: "Node", logo: Node.src },
  { title: "Express", logo: Express.src },
  { title: "Strapi", logo: Strapi.src },
  { title: "Firebase", logo: Firebase.src },
  { title: "MongoDB", logo: MongoDB.src },
  { title: "Payload", logo: Payload.src },
  { title: "Docker", logo: Docker.src },
  { title: "Wordpress", logo: Wordpress.src },
  { title: "Sendgrid", logo: Sendgrid.src },
];

export default skillsConfig;
